import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Card, CardBody } from 'reactstrap';
import {
  fetchManufacturers,
  fetchShingleTypes,
  fetchColors
} from '../api/authApi';

const MANUFACTURERS = [
  "GAF", "Owens Corning", "CertainTeed",
  "Atlas", "Tamko", "Malarky", "Pabco"
];

export function CountersPage() {
  const [manufs, setManufs] = useState({});
  const [shingles, setShingles] = useState({});
  const [colors, setColors] = useState({});
  const [selManuf, setSelManuf] = useState(null);
  const [selShingle, setSelShingle] = useState(null);

  // Load manufacturers on mount
  useEffect(() => {
    (async () => {
      const data = await fetchManufacturers();
      setManufs(data);
    })();
  }, []);

  // When manufacturer changes: reset shingle & color
  useEffect(() => {
    if (!selManuf) return;
    (async () => {
      const data = await fetchShingleTypes(selManuf);
      setShingles(data);
      setSelShingle(null);
      setColors({});
    })();
  }, [selManuf]);

  // When shingle changes: load colors
  useEffect(() => {
    if (!selManuf || !selShingle) return;
    (async () => {
      const data = await fetchColors(selManuf, selShingle);
      setColors(data);
    })();
  }, [selShingle, selManuf]);

  return (
    <div className="page-content">
      <Row className="mb-4">
        <Col>
          <h4>By Manufacturer</h4>
          {MANUFACTURERS.map(m => (
            <Button
              key={m}
              className="me-2 mb-2"
              outline
              color={selManuf === m ? "danger" : "primary"}
              onClick={() => setSelManuf(m === selManuf ? null : m)}
            >
              {m} ({manufs[m] ?? 0})
            </Button>
          ))}
        </Col>
      </Row>

      {selManuf && (
        <>
          <Row className="mb-4">
            <Col>
              <h4>Shingle Types for {selManuf}</h4>
              {Object.entries(shingles).map(([type, cnt]) => (
                <Button
                  key={type}
                  className="me-2 mb-2"
                  outline
                  color={selShingle === type ? "danger" : "secondary"}
                  onClick={() => setSelShingle(type === selShingle ? null : type)}
                >
                  {type} ({cnt})
                </Button>
              ))}
            </Col>
          </Row>
          {selShingle && (
            <Row>
              <Col md={6}>
                <Card>
                  <CardBody>
                    <h5>Colors for {selShingle}</h5>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr><th>Color</th><th>Count</th></tr>
                        </thead>
                        <tbody>
                          {Object.entries(colors).map(([col, cnt]) => (
                            <tr key={col}>
                              <td>{col}</td>
                              <td>{cnt}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
}

export default CountersPage;
